'use client';

// Background preload of the floating-chicken assets (sprite + feathers + kill SFX) at app
// boot, so the first spawn pops instantly and the claim plays without lag. Audio goes
// through the app-wide Web Audio engine (lib/audioEngine) — the SAME single AudioContext
// every other sound uses, so backgrounding/mute recovery is handled in one place.

import { loadSounds, playSfx, wireUnlock } from '../lib/audioEngine';

const IMAGE_SRCS = [
  '/chicken-cs2.webp',
  '/feather-1.webp',
  '/feather-2.webp',
  '/feather-3.webp',
  '/chicken-cyber.webp',
  '/feather-cyber-1.webp',
  '/feather-cyber-2.webp',
  '/feather-cyber-3.webp',
];

let preloadStarted = false;

function preloadImages() {
  for (const src of IMAGE_SRCS) {
    const img = new Image();
    img.src = src;
  }
}

/** Fire-and-forget background preload (idempotent). Call once on app boot. */
export function preloadChickenAssets(): void {
  if (preloadStarted || typeof window === 'undefined') return;
  preloadStarted = true;
  wireUnlock();
  preloadImages();
  void loadSounds(['killchicken']).catch(() => undefined);
}

/** Play the chicken kill SFX (no-op until decoded and the context is unlocked). */
export function playChickenSound(volume = 1): void {
  playSfx('killchicken', volume);
}
